import script from "./XlsReader.vue?vue&type=script&setup=true&lang=js"
export * from "./XlsReader.vue?vue&type=script&setup=true&lang=js"

import "./XlsReader.vue?vue&type=style&index=0&id=66816371&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66816371"]])

export default __exports__